/**
 * WhatsNewBadge — Version cliquable avec indicateur de nouveautes
 *
 * Remplace le texte version statique dans le sidebar.
 * Affiche un dot orange pulsant quand le user n'a pas vu la derniere version.
 */

import { useState } from 'react';
import { APP_VERSION } from '@bstock/shared';
import { useChangelog } from '../hooks/useChangelog';
import { ChangelogDrawer } from './ChangelogDrawer';

export function WhatsNewBadge() {
  const { hasUnseen } = useChangelog();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsDrawerOpen(true)}
        className="mt-2 w-full flex items-center justify-center gap-1.5 text-[10px] text-sidebar-text/50 hover:text-sidebar-text/80 transition-colors cursor-pointer"
        title="Voir les nouveautes"
      >
        <span>v{APP_VERSION}</span>
        {hasUnseen && (
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-orange-500" />
          </span>
        )}
      </button>

      <ChangelogDrawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
    </>
  );
}
